/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../../../_metronic/layout/core'
import Table from 'react-bootstrap/Table'
import Button from 'react-bootstrap/Button'
import UserService from '../../../../../services/user'
import JobService from '../../../../../services/job'
import useServices from '../../../../../utils/hooks/useServices'
import {Link} from 'react-router-dom'

const heads = [
  {
    name: '',
    label: 'Judul',
  },
  {
    name: '',
    label: 'Tanggal Melamar',
  },
  {
    name: '',
    label: 'Total Pelamar',
  },
]

const DashboardPage: FC = () => {
  const [card] = useServices(UserService.dashboardAlumni)
  const [jobApply] = useServices(JobService.jobApplyHash)

  return (
    <>
      <div className='row'>
        <div className='col-md-4'>
          <div className='card-custom'>
            <h4 className='fs-2hx fw-bold text-dark me-2 lh-1 ls-n2'>
              {card?.data?.company_registerd ?? 0}
            </h4>
            <span className='text-gray-400 pt-1 fw-semibold fs-6'>Total Perusahaan Aktif</span>
          </div>
        </div>
        <div className='col-md-4'>
          <div className='card-custom'>
            <h4 className='fs-2hx fw-bold text-dark me-2 lh-1 ls-n2'>
              {card?.data?.company_jobs ?? 0}
            </h4>
            <span className='text-gray-400 pt-1 fw-semibold fs-6'>Total Lowongan Aktif</span>
          </div>
        </div>
        <div className='col-md-4'>
          <div className='card-custom'>
            <h4 className='fs-2hx fw-bold text-dark me-2 lh-1 ls-n2'>
              {card?.data?.jobs_already_applied ?? 0}
            </h4>
            <span className='text-gray-400 pt-1 fw-semibold fs-6'>
              Total Lowongan yang sudah dilamar
            </span>
          </div>
        </div>
      </div>
      <br />
      <div className='row'>
        <div className='col-md-12'>
          <div className='card-custom'>
            <div className='row'>
              <div className='col-md-6'>
                <h4>Lowongan Pekerjaan</h4>
              </div>
              {/* <div className='col-md-6 text-end'>
                <Link to={'/my-applicant'} className='link-primary'>
                  Lihat Semua
                </Link>
              </div> */}
            </div>
            <span>Status terbaru lowongan pekerjaan yang saya ajukan</span>
            <Table responsive className='table-striped align-middle'>
              <thead>
                <tr>
                  <th>#</th>
                  {heads.map((item, index) => (
                    <th key={index}>{item.label}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {jobApply?.data?.data.map((item: any, key: any) => {
                  return (
                    <tr key={key}>
                      <td>{key + 1}</td>
                      <td>{item?.company_job?.company_jobs_title}</td>
                      <td>{new Date(item?.created_at).toLocaleString()}</td>
                      <td style={{textAlign: 'center'}}>{item?.company_job?.total_applicants}</td>
                    </tr>
                  )
                })}
              </tbody>
            </Table>
          </div>
        </div>
      </div>
    </>
  )
}

const Dashboard: FC = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            title: 'Dashboard',
            path: '/dashboard',
            isSeparator: false,
            isActive: false,
          },
          {
            title: '/',
            path: '',
            isSeparator: false,
            isActive: false,
          },
        ]}
      >
        Dashboard
      </PageTitle>
      <DashboardPage />
    </>
  )
}

export default Dashboard
